var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, ModelSync, Vue, Watch, Model } from 'vue-property-decorator';
import { AnyInput, ExprInput } from "../../../../../lib/exports";
let JsExpr = class JsExpr extends Vue {
  onValueChange(val) {
    this.$emit('change', val);
  }
  render() {
    const h = arguments[0];
    return h("div", {
      "class": "uc-propForm-input"
    }, [h(ExprInput, {
      "attrs": {
        "multiple-line": true
      },
      "model": {
        value: this.value.$expr,
        callback: $$v => {
          this.$set(this.value, "$expr", $$v);
        }
      }
    })]);
  }
};
__decorate([Model('change', {
  type: Object
})], JsExpr.prototype, "value", void 0);
__decorate([Watch('value', {
  deep: true
})], JsExpr.prototype, "onValueChange", null);
JsExpr = __decorate([Component({
  name: 'JsExpr'
})], JsExpr);
export { JsExpr };
let InteropableInput = class InteropableInput extends Vue {
  render() {
    const h = arguments[0];
    return h("div", {
      "class": "uc-propForm-input"
    }, [h(ExprInput, {
      "attrs": {
        "type": "interopable-string"
      },
      "model": {
        value: this.valueInter,
        callback: $$v => {
          this.valueInter = $$v;
        }
      }
    })]);
  }
};
__decorate([ModelSync('value', 'change', {
  type: String
})], InteropableInput.prototype, "valueInter", void 0);
InteropableInput = __decorate([Component({
  name: 'InteropableInput'
})], InteropableInput);
export { InteropableInput };
let AnyInputNoIcon = class AnyInputNoIcon extends Vue {
  render() {
    const h = arguments[0];
    return h("div", {
      "class": "uc-propForm-input"
    }, [h(AnyInput, {
      "attrs": {
        "hideIcon": true
      },
      "model": {
        value: this.valueInter,
        callback: $$v => {
          this.valueInter = $$v;
        }
      }
    })]);
  }
};
__decorate([ModelSync('value', 'change', {
  type: String
})], AnyInputNoIcon.prototype, "valueInter", void 0);
AnyInputNoIcon = __decorate([Component({
  name: 'AnyInputNoIcon'
})], AnyInputNoIcon);
export { AnyInputNoIcon };
//# sourceMappingURL=ParamItemInputModes.js.map
